import React from 'react';
import './languageChange.scss';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { US, RU, AM, ES } from 'country-flag-icons/react/3x2';
import { useLocation, useNavigate } from 'react-router-dom';
import { getCurrentLang } from '../../utils/withLang';

const languages = {
  en: { label: 'English', Flag: US },
  hy: { label: 'Հայերեն', Flag: AM },
  ru: { label: 'Русский', Flag: RU },
  es: { label: 'Español', Flag: ES },
};

const LanguageChange = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const currentLang = getCurrentLang(location.pathname) || 'en';
  const current = languages[currentLang] || languages.en;
  const CurrentFlag = current.Flag;

  const handleLanguageChange = newLang => {
    const updatedPath = location.pathname.replace(/^\/(en|hy|ru|es)/, `/${newLang}`);
    i18n.changeLanguage(newLang);
    navigate(updatedPath);
  };

  return (
    <div className="languageChange">
      <DropdownButton
        id="language-dropdown"
        align="end"
        variant="light"
        // Title now includes hidden text so it is always "descriptive"
        title={
          <span className="language-toggle">
            <CurrentFlag className="flag-icon" aria-hidden="true" focusable="false" />
            <span className="sr-only">{`Current language: ${current.label}`}</span>
          </span>
        }
        aria-label={`Current language: ${current.label}`}
      >
        {Object.entries(languages)
          .filter(([code]) => code !== currentLang)
          .map(([code, { label, Flag }]) => (
            <Dropdown.Item
              key={code}
              as="button" // ✅ forces <button>, not <a>
              type="button"
              onClick={() => handleLanguageChange(code)}
              className="dropdown-item"
              aria-label={`Switch to ${label}`}
            >
              <span className="dropdown-item-content">
                <Flag className="flag-icon" aria-hidden="true" focusable="false" />
                <span className="language-label">{label}</span>
              </span>
            </Dropdown.Item>
          ))}
      </DropdownButton>
    </div>
  );
};

export default LanguageChange;
